export { default as ProductsIndexPageHeaderSearchInput } from './ProductsIndexPageHeaderSearchInput';
